import React from "react";
import { Container } from "./styles";
import { useBreakpoint } from "gatsby-plugin-breakpoints/BreakpointProvider";
import gemscapes from "../../images/gemscapes.svg";

const HeroSection = ({ isDesktop }) => {
  const breakpoints = useBreakpoint();
  return (
    <Container>
      <div className="wave-form">
        {!breakpoints.md && <img src={gemscapes} alt="gemscape" />}
      </div>
      <div className="hero-section">
        <h1 className="header">
          minimalist acoustic music for production and pleasure
        </h1>
        {breakpoints.md && (
          <img src={gemscapes} alt="gemscape" className="gemscape-mobile" />
        )}
        <button
          className="hero-button"
          onClick={() => {
            window.location = process.env.GATSBY_BLUE_DOT_APP_URL;
          }}
        >
          Explore the library
        </button>
        <p className="sub-text">
          Search thousands of tracks composed and recorded at Blue Dot Studios
        </p>
      </div>
    </Container>
  );
};

export default HeroSection;
